module.exports = __webpack_public_path__ + "media/images/illustrations/mover_waving-b696f8171a260e09d7a4b40b05eedc82.svg";